export enum VectorType {
    FLAT = 0,
    CONST = 1,
    SEQUENCE = 2,
    DICTIONARY = 3,
    FSST_DICTIONARY = 4,
}
